import { ContributionEnumerationInterface } from '../interfaces/contribution.enumeration.interface';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ContributionEnumerationModel')
export class ContributionEnumerationModel
  implements ContributionEnumerationInterface
{
  @JsonProperty('Code', String, true)
  code: string = undefined;

  @JsonProperty('Description', String, true)
  description: string = undefined;

  @JsonProperty('Id', String, true)
  id: string = undefined;

  @JsonProperty('Models', String, true)
  models: string = undefined;
}
